export default __webpack_public_path__ + "static/media/CS-Septiembre(1440x600).d1d8b88a.webp";